import {Component} from 'react';
import {RadioBox} from './radiobox';

class ReductionEligibility extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedOption: null,
			validationError: false, // Track if there's a validation error for the radio selection
		};
	}

	handleOptionChange = (value, modelName) => {
		this.setState({
			selectedOption: value
		});
		
		// Send selection to parent when option changes
		if (this.props.onDataCollected) {
			this.props.onDataCollected({
				selectedOption: value
			});
		}
	}

	// Public method to validate if a selection has been made
	validateSelection = () => {
		if (this.state.selectedOption === null) {
			// Show validation error
			this.setState({
				validationError: true
			});
			return false;
		}
		// Clear validation error if validation passes
		if (this.state.validationError) {
			this.setState({
				validationError: false
			});
		}
		return true;
	}

	// Method that can be called to check if selection has been completed
	// This is called by parent to check if the step is completed before proceeding
	isCompleted = () => {
		return this.state.selectedOption !== null;
	}
	
	// Method that can be called to get the current selection data
	// This allows the parent component to retrieve data when the button is clicked
	getData = () => {
		return {
			selectedOption: this.state.selectedOption
		};
	}
	
	// Method that can be called by parent to submit the current selection
	// This allows the parent component to trigger data collection when the button is clicked
	submitSelection = () => {
		// Send the collected data to the parent component
		if (this.props.onDataCollected) {
			const data = {
				selectedOption: this.state.selectedOption
			};
			this.props.onDataCollected(data);
		}
		return true; // Indicate success
	}

	render() {
		const {selectedOption} = this.state;
		
		// Check if current day is weekend
		const today = new Date();
		const isWeekend = today.getDay() === 0 || today.getDay() === 6; // Sunday (0) or Saturday (6)
		
		// Check if current time is outside business hours (before 10 AM or after 6 PM)
		const nowHour = today.getHours();
		const outOfRangeHours = nowHour < 10 || nowHour >= 18;
		
		// Define options based on whether it's weekend or out of business hours
		let options;
		if (isWeekend || outOfRangeHours) {
			// On weekends or outside business hours, show "Oui, mais à un autre moment" and "Non" options
			options = {
				'Oui, je choisis mon créneau': 'later',
				'Non, je ne veux pas être rappelé(e)': 'no'
			};
		} else {
			// On normal days during business hours, show all three options
			options = {
				'Oui, juste après la simulation': 'oui',
				'Oui, mais à un autre moment': 'later',
				'Non, je ne veux pas être rappelé(e)': 'no'
			};
		}
		
		// Use alternative text for difficulte step if provided
		const displayText = this.props.alternativeText && this.props.fromStep === 'difficulte' 
			? <span dangerouslySetInnerHTML={{ __html: this.props.alternativeText }} />
			: <span>
				<strong>Voulez-vous être aidé gratuitement dans la mise en place des contrats de votre nouveau logement (électricité, internet, assurance) afin de bénéficier de tarifs avantageux ?</strong>
				Notre partenaire papernest vous appellera directement par téléphone - 100% gratuit
			</span>;
		
		return (
			<div className="reduction-eligibility">
				<RadioBox 
					name="reduction_eligibility"
					options={options}
					handler={this.handleOptionChange}
					defaultValue={selectedOption}
					modelName="reductionEligibility"
				>
					{displayText}
				</RadioBox>
			</div>
		);
	}
}

export default ReductionEligibility;